export default "__VITE_ASSET__d574df3e__"